<template lang="html">
  <div class="loading">
    <img src="../assets/loading.gif" alt="">
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
.loading{
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 999999;
}
.loading > img{
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1rem;
  height: 1rem;
  margin-top: -.5rem;
  margin-left: -.5rem;
}
</style>



// WEBPACK FOOTER //
// loading.vue?3cb3f7e0